import Chip from '@mui/material/Chip';
import React from 'react';

function TableFilterListItem({ label, value, onDelete, className }) {
  return (
    <Chip
      label={label}
      value={value}
      onDelete={() => onDelete(value)}
      sx={className}
    />
  );
}

export default TableFilterListItem;
